import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const Switcher = styled.p`
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  color: inherited;
  margin: 0;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language;

  const changeLanguage = () => {
    const newLang = currentLang === "en" ? "fr" : "en";
    i18n.changeLanguage(newLang);
  };

  return (
    <Switcher onClick={changeLanguage}>
      {currentLang === "en" ? "Français" : "English"}
    </Switcher>
  );
};

export default LanguageSwitcher;